export const whatsAppLinkFormatter = (phoneNumber: string, subject: string) => {
  if (phoneNumber.startsWith('05')) {
    phoneNumber = `972${phoneNumber.slice(1)}`;
  }
  return `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(subject)}`;
};
